//#region
import PropTypes from 'prop-types';
// material
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import RoleRow from './RoleRow';
//#endregion

export default function RoleTable({ list, openInPopup, deleteRole, pageNo, itemsPerPage, ...other }) {
    return (
        <TableContainer component={Paper} {...other}>
            <Table aria-label="customized table">
                <TableHead >
                    <TableRow className='cm_table_head'>
                        <TableCell >#</TableCell>
                        <TableCell >Name</TableCell>
                        <TableCell >User Type</TableCell>
                        <TableCell >Last Modified</TableCell>
                        <TableCell >Action</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {list && list.length > 0 && list.map((row, i) => (
                        <RoleRow key={i} role={row} index={(i + 1) + ((pageNo - 1) * itemsPerPage)} openInPopup={openInPopup} deleteRole={deleteRole} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

RoleTable.propTypes = {
    list: PropTypes.array.isRequired
}